import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { ReactComponent as XMarkIcon } from '../../images/xmark-solid.svg';

function OptionPicker({
  title,
  options,
  isOpen,
  setIsOpen,
  selectOption,
}: {
  title: string;
  options: string[];
  isOpen: boolean;
  setIsOpen: (a: boolean) => void;
  selectOption: (a: string) => void;
}) {
  const [query, setQuery] = useState('');

  const filteredOptions = query === '' ? options : options.filter((option) => option.includes(query.toUpperCase()));

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-slate-900 bg-opacity-60">
        <Dialog.Panel
          className={`scroll h-full w-full max-w-[1000px] overflow-y-scroll bg-blue-50 shadow-md lg:h-4/5 lg:rounded-md`}>
          <div className="sticky top-0 flex items-end justify-between bg-gls-sky-blue p-2 lg:px-4">
            <Dialog.Title className={`text-2xl font-semibold capitalize text-sky-900 lg:text-3xl`}>
              {title}
            </Dialog.Title>
            <XMarkIcon fill="white" className="h-10 w-10 rounded-lg bg-sky-600 p-1" onClick={() => setIsOpen(false)} />
          </div>

          <div className="flex items-center space-x-2 py-2 pl-8 text-lg font-semibold">
            <label htmlFor="routeFilterQuery">Filter Routes:</label>
            <input
              type="text"
              id="routeFilterQuery"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-32 rounded border border-gray-500 bg-white py-1 px-2"
            />
          </div>
          <div
            className={`my-8 grid grid-cols-1 ${
              filteredOptions.length < 12
                ? 'md:grid-cols-1'
                : filteredOptions.length < 22
                ? 'md:grid-cols-2'
                : 'md:grid-cols-3'
            } grid-flow-row space-x-1 space-y-1`}>
            {filteredOptions.map((option) => {
              return (
                <div
                  key={option}
                  onClick={() => {
                    selectOption(option);
                    setIsOpen(false);
                  }}
                  className={`rounded border border-sky-200 bg-sky-100 px-10 py-2 text-center text-xl hover:cursor-pointer ${
                    filteredOptions.length < 22 ? 'py-2' : 'py-1'
                  }`}>
                  {option}
                </div>
              );
            })}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default OptionPicker;
